import { render, staticRenderFns } from "./BlockTeamsItem.vue?vue&type=template&id=7436d209&"
import script from "./BlockTeamsItem.vue?vue&type=script&lang=js&"
export * from "./BlockTeamsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports